import { title } from "@/components/primitives";
import DefaultLayout from "@/layouts/default";

export default function BecomePremium() {
  return (
    <DefaultLayout>
      <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
        <div className="inline-block max-w-lg text-center justify-center">
          <h1 className={title()}>Become Emsbt Premium</h1>
          <p className="text-lg text-center text-muted-foreground m-6">
          Features will be announced soon.
          </p>
          <p className="text-lg text-center text-muted-foreground m-6">
            Contact us at{" "}
            <a href="mailto:mailto:info@emsbt.ai" className=" underline">
              {" "}
              info@emsbt.ai{" "}
            </a>
          </p>
        </div>
      </section>
    </DefaultLayout>
  );
}